var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcon = function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 22,
    viewBox: "0 0 24 22"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f6a000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.731 14.857c-.786 0-1.445.652-1.445 1.429s.659 1.428 1.445 1.428c.757 0 1.445-.651 1.41-1.394.035-.817-.618-1.463-1.41-1.463z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.416 19.585c.775-1.323.78-2.9.01-4.218L15.7 2.124C14.935.791 13.554 0 12.005 0c-1.55 0-2.93.796-3.696 2.12L.574 15.375c-.77 1.333-.765 2.92.014 4.244.77 1.308 2.146 2.094 3.686 2.094h15.432c1.544 0 2.93-.796 3.71-2.129zm-1.677-.957c-.43.733-1.19 1.167-2.038 1.167H4.269c-.839 0-1.594-.425-2.013-1.142-.424-.728-.43-1.597-.005-2.33L9.987 3.072c.42-.727 1.17-1.157 2.018-1.157.843 0 1.598.435 2.017 1.162l7.731 13.252c.415.713.41 1.573-.014 2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.378 6.321c-.674.171-1.092.714-1.092 1.373.034.397.062.8.096 1.197l.288 4.51c.034.513.481.885 1.058.885.578 0 1.03-.398 1.058-.915 0-.312 0-.599.034-.916.063-.97.13-1.94.193-2.91.034-.63.096-1.258.13-1.886 0-.227-.034-.428-.13-.629-.289-.563-.962-.85-1.635-.709z"
  }))));
};
export default SvgIcon;